import { Tooltip } from 'antd';
import { observer } from 'mobx-react-lite';
import { EllipsisContainer } from 'src/components/EllipsisContainer/EllipsisContainer';
import { EntityStatusInfo } from 'src/components/EntityStatusInfo/EntityStatusInfo';
import {
    MainContainer,
    MainEntityListItemText,
    MasterDetailsAsideItem,
    SecondaryContainer,
    SecondaryEntityListItemText,
} from 'src/components/MasterDetailsPage/MasterDetailsAsideItem';
import { EntityLinks } from 'src/core/router/EntityLinks';
import {
    LegalEntityDto,
    LoanApplicationDtoBrief,
    PersonDto,
} from 'src/generated-api-client';
import { ApplicationStatusInfoMap } from 'src/pages/LoanApplicationsPage/ApplicationStatusInfoMap';
import { DateHelper } from 'src/utils/DateHelper';
import { FullNameHelper } from 'src/utils/FullNameHelper';

type AgentLoanApplicationListItemProps = { item: LoanApplicationDtoBrief };

export const AgentLoanApplicationListItem = observer(
    ({ item }: AgentLoanApplicationListItemProps) => {
        const fullName = FullNameHelper(
            item.borrower as LegalEntityDto | PersonDto,
        );

        return (
            <MasterDetailsAsideItem
                to={EntityLinks.agentLoanApplications.itemDetails(item.id)}
            >
                <MainContainer>
                    <Tooltip title={fullName}>
                        <EllipsisContainer>
                            <MainEntityListItemText className="strong-text">{`${item.number} `}</MainEntityListItemText>
                            <MainEntityListItemText data-testid="borrower-name">
                                {fullName}
                            </MainEntityListItemText>
                        </EllipsisContainer>
                    </Tooltip>
                    <EntityStatusInfo
                        statusInfoMap={ApplicationStatusInfoMap}
                        status={item.status}
                        entityName="application"
                    />
                </MainContainer>
                <SecondaryContainer>
                    <SecondaryEntityListItemText>
                        <span
                            className="strong-text"
                            data-testid="campaign-name"
                        >
                            {item?.campaign?.name}
                        </span>
                    </SecondaryEntityListItemText>
                    <SecondaryEntityListItemText data-testid="requestedAt">
                        {DateHelper.format(item.requestedAt || '')}
                    </SecondaryEntityListItemText>
                </SecondaryContainer>
            </MasterDetailsAsideItem>
        );
    },
);
